<template>
  <a href="#content" rel="nofollow" class="visually-hidden-focusable">Pasar al contenido principal</a>
  <AppHeader :title="headerTitle" :description="headerDescription" :icon="headerIcon" :iconDark="headerIconDark" />
  <!-- Aquí se pinta el contenido de las view -->
  <router-view/>
</template>

<script>
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import AppHeader from './components/AppHeader.vue'
import languageService from './services/languageService';

  export default {
    name: 'App',
    components: {
      AppHeader,
    },

    setup() {
      const route = useRoute();
      const { t } = useI18n();

      const headerTitle = computed(() => t(route.meta.title || ''));
      const headerDescription = computed(() => t(route.meta.description || ''));
      const headerIcon = computed(() => route.meta.icon || ''); 
      const headerIconDark = computed(() => route.meta.iconDark || '');  

      languageService.setLanguage(localStorage.getItem('language') || (navigator.language.split('-')[0]) || 'es');
      
      return {
        headerTitle,
        headerDescription,
        headerIcon,
        headerIconDark
      };
    }
  }
</script>
